module.exports = __webpack_public_path__ + "img/nexultraLVertical.3496f0cd.jpg";